/**
 * The tabs of a dataset's page. Each value is the URL segment after
 * `/datasets/:datasetPath` that opens the tab: `DatasetsRoutes` registers the
 * tab's route at that segment, `Goto.createDatasetTabRoute` links to it, and
 * the tab strip reads it back to mark the active tab.
 */
export enum DatasetTab {
  Files = "files",
  Topics = "topics",
  Sessions = "sessions",
  Events = "events",
  Actions = "actions",
  AgentThreads = "agent-threads",
  AISummary = "summary",
  Details = "details",
  Permissions = "permissions",
}
